import { DefinedColumns } from '@vindr/services/interfaces';
import { formatDateColumn } from '@vindr/utils/dateTime';
import { useTranslation } from 'react-i18next';

const DateColumn = <T extends Record<any, any>>(props?: CreateAtColumnProps<T>) => {
  const { t } = useTranslation('Vindoc');

  const {
    title,
    dataIndex,
    width = 140,
    key,
    sorter = true,
    showTime = true,
    type,
    ellipsis = true,
    ...rest
  } = props || {};

  const Type: TypeDateColumn<T> = {
    created_at: {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    updated_at: {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
    },
  };

  return {
    title: t(title || Type[type]?.title),
    dataIndex: dataIndex || Type[type].dataIndex,
    key: key || Type[type].key,
    width,
    sorter,
    ellipsis,
    render: (text) => formatDateColumn(text, showTime),
    ...rest,
  };
};

export default DateColumn;

type KeyColumnDate<T> = Pick<DefinedColumns<T>, 'title' | 'dataIndex' | 'key'>;

type TypeDateColumn<T> = {
  [key in Extract<KeyColumnDate<T>['key'], 'created_at' | 'updated_at'>]: KeyColumnDate<T>;
};

type DateColumnCommonProps<T> = Omit<DefinedColumns<T>, 'key' | 'dataIndex'> & {
  showTime?: boolean;
};

interface WithType<T> extends DateColumnCommonProps<T> {
  type: keyof TypeDateColumn<T>;
  key?: keyof T;
  dataIndex?: keyof T | (keyof T)[];
}

interface WithoutType<T> extends DateColumnCommonProps<T> {
  type?: keyof TypeDateColumn<T>;
  key: keyof T;
  dataIndex: keyof T | (keyof T)[];
}

export type CreateAtColumnProps<T> = WithType<T> | WithoutType<T>;
